var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHardDriveFill = function SvgHardDriveFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16q.625 0 1.063-.425T18.5 14.5q0-.625-.437-1.062A1.45 1.45 0 0 0 17 13q-.65 0-1.075.438A1.47 1.47 0 0 0 15.5 14.5q0 .65.425 1.075T17 16M2 9l3.4-3.4q.275-.276.637-.437Q6.4 5 6.826 5H17.15q.425 0 .788.162.362.163.637.438L22 9zm2 10q-.85 0-1.425-.575Q2 17.851 2 17v-6h20v6q0 .85-.587 1.425A1.95 1.95 0 0 1 20 19z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHardDriveFill);
export { ForwardRef as ReactComponent };